import { Select, type SelectProps } from '@mantine/core'
import { forwardRef } from 'react'

export interface SelectInputProps extends SelectProps {}

// Forwards its ref so components that position against their child — Tooltip,
// Popover — can reach the input instead of silently failing to attach.
export const SelectInput = forwardRef<HTMLInputElement, SelectInputProps>((props, ref) => (
  <Select
    ref={ref}
    mb='xs'
    radius='md'
    searchable
    selectOnBlur
    withinPortal
    zIndex={1002}
    {...props}
  />
))

SelectInput.displayName = 'SelectInput'
